import { IMovementScheduleFli, ItemType } from '@modeso/types__aumico-lib-annualreport-be';

export interface IMovementScheduleFliForNotes extends IMovementScheduleFli {
    itemType: ItemType;
    type: string;
}
